import { render, staticRenderFns } from "./ModalEditBatchProcessing.vue?vue&type=template&id=478cf7c6"
import script from "./ModalEditBatchProcessing.vue?vue&type=script&lang=js"
export * from "./ModalEditBatchProcessing.vue?vue&type=script&lang=js"
import style0 from "./ModalEditBatchProcessing.vue?vue&type=style&index=0&id=478cf7c6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478cf7c6')) {
      api.createRecord('478cf7c6', component.options)
    } else {
      api.reload('478cf7c6', component.options)
    }
    module.hot.accept("./ModalEditBatchProcessing.vue?vue&type=template&id=478cf7c6", function () {
      api.rerender('478cf7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalEditBatchProcessing.vue"
export default component.exports